import { getCurrentUser } from '../services/store-service';

export const CRON_PERIODS = {
    '*/2': 'Every two months',
    '*/3': 'Quarterly',
    '*/4': 'Every four months',
    '*/6': 'Biannually'
};

export const CRON_MONTHS = {
    '1': 'January',
    '2': 'February',
    '3': 'March',
    '4': 'April',
    '5': 'May',
    '6': 'June',
    '7': 'July',
    '8': 'August',
    '9': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December',
};

const getLocalHour = (hour, cronTZOffset) => {
    const localHour = hour + ((cronTZOffset || 0) - (getCurrentUser().tz_offset || 0)) / 60;

    return localHour;
}

export const getFriendlyDayName = (day = '0', short) => {
    let dayName;
    switch (day.toString()) {
        case '0':
            dayName = 'Sunday';
            break;
        case '1':
            dayName = 'Monday';
            break;
        case '2':
            dayName = 'Tuesday';
            break;
        case '3':
            dayName = 'Wednesday';
            break;
        case '4':
            dayName = 'Thursday';
            break;
        case '5':
            dayName = 'Friday';
            break;
        case '6':
            dayName = 'Saturday';
            break;

        default:
            // es lint
    }

    if (short) {
        return dayName[0];
    }

    return dayName;
}

export const encodeCronString = params => {
    const result = [];

    // Minute and Hour
    if (params.cronStartAt) {
        const [ hours, minutes ] = params.cronStartAt.split(':');

        if (!hours || !minutes || isNaN(hours - 0) || isNaN(minutes - 0) || hours - 0 > 23 || minutes - 0 > 60) {
            return {
                error: true,
                message: 'Please enter valid At time'
            };
        }

        result.push(minutes - 0);
        result.push(hours - 0);
    } else {
        result.push('*', '*')
    }

    // Day of Month
    if (['month', 'period', 'year'].includes(params.cronType) && !params.cronBiWeekly) {
        if (!params.cronDayOfMonth || isNaN(params.cronDayOfMonth - 0) || params.cronDayOfMonth - 0 > 31) {
            return {
                error: true,
                message: 'Please enter month day between 1-31'
            };
        }

        result.push(params.cronDayOfMonth);
    } else {
        result.push('*');
    }

    // Month
    if (params.cronType === 'period' && !params.cronBiWeekly) {
        result.push(params.cronMonth);
    } else if (params.cronType === 'year') {
        if (!params.cronMonth || isNaN(params.cronMonth - 0) || params.cronMonth - 0 > 12) {
            return {
                error: true,
                message: 'Please enter month between 1-12'
            };
        }

        result.push(params.cronMonth);
    } else {
        result.push('*');
    }

    if (['week', 'day'].includes(params.cronType) || params.cronBiWeekly) {
        if (!params.cronDayOfWeek.length) {
            return {
                error: true,
                message: 'Please select the day(s) for this task.'
            };
        }

        result.push(params.cronDayOfWeek.join(','));
    } else {
        result.push('*');
    }

    return result.join(' ');
}

const getCronType = ({ cronDayOfMonth, cronMonth, cronDayOfWeek, biWeekly }) => {
    if (cronMonth || biWeekly) {
        if (cronMonth.indexOf('*/') >= 0 || biWeekly) {
            return 'period';
        }

        return 'year';
    }

    if (cronDayOfMonth) {
        return 'month';
    }

    if (cronDayOfWeek.length !== 1) {
        return 'day';
    }

    return 'week'
}

export const decodeCronString = ({ cronString = '', biWeekly, cronTZOffset }) => {
    if (!cronString) {
        return {
            cronType: null,
            cronStartAt: '09:00',
            cronDayOfMonth: 1,
            cronMonth: null,
            cronBiWeekly: biWeekly || 0,
            cronDayOfWeek: []
        };
    }

    const [ startAtMinute, startAtHour, dayOfMonth, month, dayOfWeek ] = cronString.split(' ');

    let showTimezone = false;
    let cronDayOfWeek = dayOfWeek === '*' ? [] : (dayOfWeek || '').split(',');
    const cronDayOfMonth = dayOfMonth === '*' ? '' : dayOfMonth;
    const cronMonth = month === '*' ? '' : month
    let localStartAtHour = getLocalHour(startAtHour - 0, cronTZOffset);

    if (localStartAtHour >= 24 || localStartAtHour < 0) {
        showTimezone = true;
        localStartAtHour = startAtHour - 0;
    }

    return {
        cronType: getCronType({ cronDayOfMonth, cronMonth, cronDayOfWeek, biWeekly }),
        cronStartAt: `${localStartAtHour.toString().padStart(2, '0')}:${startAtMinute.padStart(2, '0')}`,
        cronDayOfMonth,
        cronMonth,
        cronDayOfWeek,
        cronBiWeekly: biWeekly || 0,
        showTimezone
    };
}
